/**
 * Wire-format invoice status. The backend serializes the InvoiceStatus enum as a string via
 * JsonStringEnumConverter. The two-value union mirrors the canonical lifecycle: Open invoices
 * can be marked Paid; Paid is terminal.
 */
export type InvoiceStatus = 'Open' | 'Paid';

const KNOWN_STATUSES: readonly InvoiceStatus[] = ['Open', 'Paid'];

export function normalizeInvoiceStatus(
  status: InvoiceStatus | string | number | null | undefined,
): InvoiceStatus {
  if (typeof status === 'string') {
    const match = KNOWN_STATUSES.find((candidate) => candidate === status);
    return match ?? 'Open';
  }
  if (typeof status === 'number') {
    // Backend numeric ordering: Open = 0, Paid = 1.
    return status === 1 ? 'Paid' : 'Open';
  }
  return 'Open';
}

export function getInvoiceStatusLabelKey(
  status: InvoiceStatus | string | number | null | undefined,
): string {
  const normalized = normalizeInvoiceStatus(status);
  return `COMPONENTS.INVOICES.STATUSES.${normalized.toUpperCase()}`;
}

/**
 * Mark-paid eligibility — only Open invoices can be marked Paid.
 */
export function canMarkInvoicePaid(
  status: InvoiceStatus | string | number | null | undefined,
): boolean {
  return normalizeInvoiceStatus(status) === 'Open';
}
